import { SafePromise, SafeError } from '@benzinga/safe-await';
import { ChatBadge, UserAvatar } from './entities';

export interface IUserProfile {
  avatar: string;
  badges: ChatBadge[];
  key: string;
  uuid: string;
  user: number;
}

export const ingestAvatar = async (incomingUserProfile: SafePromise<IUserProfile>): SafePromise<UserAvatar> => {
  const avatarResponse = await incomingUserProfile;

  if (avatarResponse.err) {
    return { err: avatarResponse.err };
  } else {
    if (avatarResponse.ok) {
      return {
        ok: {
          avatar: avatarResponse.ok.avatar,
          badges: avatarResponse.ok.badges,
          key: avatarResponse.ok.key,
          user: avatarResponse.ok.user,
          uuid: avatarResponse.ok.uuid,
        },
      };
    } else {
      return { err: new SafeError('did not get a valid chat avatar response', 'invalid_chat_avatar') };
    }
  }
};
